import * as Sentry from "@sentry/vue";
import onboardingStatusStore from "@/store/onboarding.store";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const captureException = (error: any): void => {
    const tags = {
        businessName: onboardingStatusStore.state.onboardingStatus?.business.name,
        importedFrom: onboardingStatusStore.state.onboardingStatus?.business.importedFrom,
        product: onboardingStatusStore.state.onboardingStatus?.product,
    };  

    Sentry.
        captureException(new Error(`Onboarding process failure for business: ${onboardingStatusStore
            .state.onboardingStatus?.business.id}`), {
        extra: error,
        tags,
    });
};

export default {
    captureEvent: captureException,
};
